// @flow

import _ from 'lodash/fp';
import {
  GET_REQUEST, GET_SUCCESS,
  GET_FAILURE, UPDATE_REQUEST,
  UPDATE_SUCCESS, UPDATE_FAILURE,
  CREATE_REQUEST, CREATE_SUCCESS,
  CREATE_FAILURE, ROOM_UPDATE_SUCCESS,
  SELECT_ROOM, SELECT_PRODUCT_SLOT,
  ROOM_UPDATE_REQUEST, ROOM_UPDATE_FAILURE,
  ROOM_CREATE_SUCCESS, ROOM_CREATE_REQUEST,
  ROOM_CREATE_FAILURE, PRODUCT_SLOT_UPDATE_SUCCESS,
  PRODUCT_SLOT_UPDATE_REQUEST, PRODUCT_SLOT_UPDATE_FAILURE,
  PRODUCT_SLOT_CREATE_SUCCESS, PRODUCT_SLOT_CREATE_REQUEST,
  PRODUCT_SLOT_CREATE_FAILURE, CLEAR,
  OPEN_DIALOG_REQUEST, OPEN_DIALOG_FAILURE,
  OPEN_DIALOG_SUCCESS, CLOSE_DIALOG,
  POP_DIALOG_NAVIGATION, NAVIGATE_TO_VARIANT_REQUEST,
  NAVIGATE_TO_VARIANT_FAILURE, NAVIGATE_TO_VARIANT_SUCCESS,
  UPDATE_RELATED_VARIANT, TOGGLE_VARIANT_REQUEST,
  TOGGLE_VARIANT_FAILURE, TOGGLE_VARIANT_SUCCESS,
  SET_STANDARD_PRODUCT, RESET,
  TOGGLE_PRODUCT, CHECK_ALL_VARIANTS,
  CLEAR_STANDARD_PRODUCT, CHECK_PRODUCT,
  UPDATE_VARIANTS, ROOMS_UPDATE_REQUEST,
  ROOMS_UPDATE_FAILURE, ROOMS_UPDATE_SUCCESS,
  PRODUCT_SLOTS_UPDATE_REQUEST, PRODUCT_SLOTS_UPDATE_FAILURE,
  PRODUCT_SLOTS_UPDATE_SUCCESS, UPDATE_VARIANTS_FOR_TYPE,
} from '../actions/apartmentConfigView';
import {SET_DIRTY} from '../actions/form';
import {
  defaultDialogState,
  handleError,
  openDialog,
  openDialogRequest,
  navigateToVariant,
  navigateToVariantRequest,
  toggleVariant,
  toggleVariantRequest,
  popNavigation,
  updateRelatedVariant,
  setStandardProduct,
  prepareDialog,
  closeDialog,
  resetDialog,
  toggleProduct,
  checkAllVariants,
  clearStandardProduct,
  checkProduct,
  updateVariants,
  updateVariantsForType,
  sortByIndex,
  sortRoomList,
} from './configTemplateView';
import type {
  ConfigTemplateState as ApartmentConfigState,
  Exact,
  ProductsState,
  ProductSlotState,
  ProductTypesState,
  ProjectsState,
  RoomState,
  RoomsState,
  RoomTemplatesState,
  RoomTypesState,
} from './configTemplateView';

type ProjectState = {
  active: ?any,
  apartmentConfigs: any[],
  configTemplates: any[],
};

export type State_ = {
  apartmentConfig: ApartmentConfigState,
  products: ProductsState,
  productSlot: ProductSlotState,
  productTypes: ProductTypesState,
  project: ProjectState,
  room: RoomState,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};

type State = {
  apartmentConfig: Exact<ApartmentConfigState>,
  products: ProductsState,
  productSlot: Exact<ProductSlotState>,
  productTypes: ProductTypesState,
  project: Exact<ProjectState>,
  room: Exact<RoomState>,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};

const defaultApartmentConfigState: ApartmentConfigState = {
  active: null,
  error: null,
  isDirty: false,
  isFetching: false,
};

const defaultProductSlotState: ProductSlotState = {
  active: null,
  dialog: defaultDialogState,
  error: null,
  isDirty: false,
  isFetching: false,
  roomId: null,
};

const defaultProjectState: ProjectState = {
  active: null,
  apartmentConfigs: [],
  configTemplates: [],
};

const defaultRoomState: RoomState = {
  active: null,
  error: null,
  isDirty: false,
  isFetching: false,
};

const defaultRoomsState: RoomsState = [];

const defaultRoomTypesState: RoomTypesState = [];

const defaultProductTypesState: ProductTypesState = [];

const defaultProductsState: ProductsState = [];

const defaultProjectsState: ProjectsState = [];

const defaultRoomTemplatesState: RoomTemplatesState = [];

const defaultState: State_ = {
  apartmentConfig: defaultApartmentConfigState,
  productSlot: defaultProductSlotState,
  project: defaultProjectState,
  room: defaultRoomState,
  rooms: defaultRoomsState,
  roomTypes: defaultRoomTypesState,
  productTypes: defaultProductTypesState,
  products: defaultProductsState,
  projects: defaultProjectsState,
  roomTemplates: defaultRoomTemplatesState,
};

const apartmentConfigView = (state: State_ = defaultState, action: any): Exact<State> => {
  switch (action.type) {
    case CREATE_REQUEST:
    case UPDATE_REQUEST:
      return {
        ...state,
        apartmentConfig: {
          ...state.apartmentConfig,
          error: null,
          isFetching: true,
        },
      };
    case GET_REQUEST:
      return {
        ...defaultState,
        apartmentConfig: {
          ...defaultApartmentConfigState,
          error: null,
          isFetching: true,
        },
      };
    case CREATE_FAILURE:
    case GET_FAILURE:
    case UPDATE_FAILURE:
      return {
        ...state,
        apartmentConfig: {
          ...state.apartmentConfig,
          error: action.error,
          isFetching: false,
        },
      };
    case CREATE_SUCCESS:
      return {
        ...state,
        apartmentConfig: {
          active: action.apartmentConfig || null,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: action.apartmentConfig ? sortRoomList(action.apartmentConfig.rooms) : [],
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        apartmentConfig: {
          active: action.apartmentConfig || null,
          error: null,
          isDirty: false,
          isFetching: false,
        },
      };
    case GET_SUCCESS:
      return {
        ...state,
        apartmentConfig: {
          active: action.apartmentConfig || null,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        products: action.products,
        productTypes: action.productTypes,
        project: {
          active: action.project || null,
          apartmentConfigs: action.apartmentConfigs || [],
          configTemplates: action.configTemplates || [],
        },
        rooms: action.apartmentConfig ? sortRoomList(action.apartmentConfig.rooms) : [],
        roomTypes: action.roomTypes,
        projects: action.projects,
        roomTemplates: action.roomTemplates,
      };
    case ROOM_CREATE_REQUEST:
    case ROOM_UPDATE_REQUEST:
    case ROOMS_UPDATE_REQUEST:
      return {
        ...state,
        room: {
          ...state.room,
          error: null,
          isFetching: true,
        },
      };
    case ROOM_CREATE_FAILURE:
    case ROOM_UPDATE_FAILURE:
    case ROOMS_UPDATE_FAILURE:
      return {
        ...state,
        room: {
          ...state.room,
          error: action.error,
          isFetching: false,
        },
      };
    case ROOM_CREATE_SUCCESS:
      return {
        ...state,
        room: {
          ...state.room,
          active: action.room,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: sortRoomList([
          ...state.rooms,
          action.room,
        ]),
      };
    case ROOM_UPDATE_SUCCESS:
      return {
        ...state,
        room: {
          ...state.room,
          active: action.room,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: sortRoomList([
          ..._.reject({id: action.room.id}, state.rooms),
          action.room,
        ]),
      };
    case ROOMS_UPDATE_SUCCESS:
      return {
        ...state,
        room: {
          active: !!state.room.active
            ? _.find({id: state.room.active.id}, action.rooms)
            : state.room.active,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: sortRoomList(action.rooms),
      };
    case PRODUCT_SLOT_UPDATE_REQUEST:
    case PRODUCT_SLOT_CREATE_REQUEST:
    case PRODUCT_SLOTS_UPDATE_REQUEST:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          error: null,
          isFetching: true,
        },
      };
    case PRODUCT_SLOT_UPDATE_FAILURE:
    case PRODUCT_SLOT_CREATE_FAILURE:
    case PRODUCT_SLOTS_UPDATE_FAILURE:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          error: action.error,
          isFetching: false,
        },
      };
    case PRODUCT_SLOT_CREATE_SUCCESS: {
      const {productSlot, roomId} = action;
      const currentRoom = {..._.find({id: roomId}, state.rooms)};
      currentRoom.productSlots = currentRoom.productSlots ? [
        ...currentRoom.productSlots,
        productSlot,
      ] : [productSlot];

      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          active: productSlot,
          dialog: prepareDialog(state.productSlot.dialog, action),
          error: null,
          isDirty: false,
          isFetching: false,
          roomId: action.roomId,
        },
        rooms: sortRoomList([
          ..._.reject({id: currentRoom.id}, state.rooms),
          currentRoom,
        ]),
      };
    }
    case PRODUCT_SLOT_UPDATE_SUCCESS: {
      const {productSlot} = action;
      const currentRoom = {
        ..._.find(r => _.some({id: productSlot.id}, r.productSlots), state.rooms),
      };
      currentRoom.productSlots = [
        ..._.reject({id: productSlot.id}, currentRoom.productSlots),
        productSlot,
      ];

      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          active: productSlot,
          dialog: prepareDialog(state.productSlot.dialog, action),
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: sortRoomList([
          ..._.reject({id: currentRoom.id}, state.rooms),
          currentRoom,
        ]),
      };
    }
    case PRODUCT_SLOTS_UPDATE_SUCCESS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          active: !!state.productSlot.active
            ? _.find({id: state.productSlot.active.id}, action.productSlots)
            : state.productSlot.active,
          dialog: !!state.productSlot.active
            ? prepareDialog(state.productSlot.dialog, {
              ...action,
              productSlot: _.find({id: state.productSlot.active.id}, action.productSlots) || state.productSlot.active,
            })
            : state.productSlot.dialog,
          error: null,
          isDirty: false,
          isFetching: false,
        },
        rooms: sortRoomList([
          ..._.reject({id: action.roomId}, state.rooms),
          {
            ..._.find({id: action.roomId}, state.rooms),
            productSlots: sortByIndex(action.productSlots),
          },
        ]),
      };
    case OPEN_DIALOG_FAILURE:
    case NAVIGATE_TO_VARIANT_FAILURE:
    case TOGGLE_VARIANT_FAILURE:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: handleError(state.productSlot.dialog, action),
        },
      };
    case OPEN_DIALOG_REQUEST:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: openDialogRequest(state.productSlot.dialog, action),
        },
      };
    case NAVIGATE_TO_VARIANT_REQUEST:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: navigateToVariantRequest(state.productSlot.dialog, action),
        },
      };
    case TOGGLE_VARIANT_REQUEST:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: toggleVariantRequest(state.productSlot.dialog, action),
        },
      };
    case OPEN_DIALOG_SUCCESS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: openDialog(state.productSlot.dialog, action, state.productSlot.active),
        },
      };
    case NAVIGATE_TO_VARIANT_SUCCESS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: navigateToVariant(state.productSlot.dialog, action, state.productSlot.active),
        },
      };
    case POP_DIALOG_NAVIGATION:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: popNavigation(state.productSlot.dialog, action),
        },
      };
    case TOGGLE_VARIANT_SUCCESS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: toggleVariant(state.productSlot.dialog, action, state.productSlot.active),
        },
      };
    case UPDATE_RELATED_VARIANT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: updateRelatedVariant(state.productSlot.dialog, action),
        },
      };
    case SET_STANDARD_PRODUCT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: setStandardProduct(state.productSlot.dialog, action),
        },
      };
    case CLEAR_STANDARD_PRODUCT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: clearStandardProduct(state.productSlot.dialog, action),
        },
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: closeDialog(state.productSlot.dialog, action),
        },
      };
    case RESET:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: resetDialog(state.productSlot.dialog, action, state.productSlot.active),
        },
      };
    case TOGGLE_PRODUCT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: toggleProduct(state.productSlot.dialog, action),
        },
      };
    case CHECK_ALL_VARIANTS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: checkAllVariants(state.productSlot.dialog, action),
        },
      };
    case CHECK_PRODUCT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: checkProduct(state.productSlot.dialog, action),
        },
      };
    case UPDATE_VARIANTS:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: updateVariants(state.productSlot.dialog, action),
        },
      };
    case UPDATE_VARIANTS_FOR_TYPE:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          dialog: updateVariantsForType(state.productSlot.dialog, action),
        },
      };
    case SELECT_ROOM:
      return {
        ...state,
        productSlot: defaultProductSlotState,
        room: {
          ...state.room,
          active: action.room,
        },
      };
    case SELECT_PRODUCT_SLOT:
      return {
        ...state,
        productSlot: {
          ...state.productSlot,
          active: action.productSlot,
          dialog: prepareDialog(state.productSlot.dialog, action),
          error: null,
          isDirty: false,
          roomId: action.roomId,
        },
        room: defaultRoomState,
      };
    case SET_DIRTY:
      return {
        ...state,
        apartmentConfig: {
          ...state.apartmentConfig,
          isDirty: action.form === 'apartmentConfig'
            ? !!action.dirty
            : state.apartmentConfig.isDirty,
        },
        productSlot: {
          ...state.productSlot,
          isDirty: action.form === 'apartmentConfigProductSlot'
            ? !!action.dirty
            : state.productSlot.isDirty,
        },
        room: {
          ...state.room,
          isDirty: action.form === 'apartmentConfigRoom'
            ? !!action.dirty
            : state.room.isDirty,
        },
      };
    case CLEAR:
      return defaultState;
    default:
      return state;
  }
};

export default apartmentConfigView;



// WEBPACK FOOTER //
// ./src/reducers/apartmentConfigView.js